<template>
<div class="chapter">
<div class="inner_page">
<h1 class="P_Heading_1" id="auto_bookmark_table_of_contents_1"><span>The Mystery of Nevermore</span></h1>
<p class="P_Normal"> </p>
<p class="P_Norm-NoIndent">By C.S. Poe</p>
<p class="P_Norm-NoIndent"> </p>
<p class="P_Norm-NoIndent">Snow &amp; Winter: Book 1</p>
<p class="P_Normal"> </p>
<p class="P_Normal">It’s Christmas, and all antique dealer Sebastian Snow wants is for his business to make money and to save his floundering relationship with closeted CSU detective Neil Millett. When Snow’s Antique Emporium is broken into and a heart is found under the floorboards, Sebastian can’t let the mystery rest.</p>
<p class="P_Normal">He soon finds himself caught up in murder investigations that echo the macabre stories of Edgar Allan Poe. To make matters worse, Sebastian’s sleuthing is causing his relationship with Neil to crumble, while at the same time he’s falling hard for the lead detective on the case, Calvin Winter. Sebastian and Calvin must work together to unravel the mystery behind the killings, despite the mounting danger and sexual tension, before Sebastian becomes the next victim.</p>
<p class="P_Normal">In the end, Sebastian only wants to get out of this mess alive and live happily ever after with Calvin.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0001.vue?1a519db1